module.exports = __webpack_public_path__ + "img/mobile.eca9b4f5.jpg";